import React from 'react';
import {
	Box,
	Button,
	FormControlLabel,
	Stack,
	Switch,
	TextField,
	Typography,
} from '@mui/material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AddressAutocomplete from '../../../Components/AddressAutocomplete';
import { SectionCard, SectionHeader } from '../components/SettingsShell';

const TimeTrackingSection = ({
	formData,
	setFormData,
	saving,
	canUseTimeTracking,
	onSave,
}) => {
	const onChange = (event) => {
		const { name, value, type, checked } = event.target;
		setFormData((prev) => ({
			...prev,
			[name]: type === 'checkbox' ? checked : value,
		}));
	};

	return (
		<SectionCard>
			<SectionHeader
				icon={AccessTimeOutlinedIcon}
				title="Time tracking"
				description="Shop location and clock-in / clock-out rules for attendance geofencing."
			/>

			{!canUseTimeTracking ? (
				<Typography variant="body2" color="text.secondary">
					Time tracking is available on the Pro plan.
				</Typography>
			) : (
				<Box component="form" onSubmit={onSave} noValidate>
					<Stack spacing={{ xs: 2, sm: 2.5 }}>
						<AddressAutocomplete
							label="Shop address"
							value={formData.shop_address}
							latitude={formData.shop_latitude}
							longitude={formData.shop_longitude}
							onChange={({ address, latitude, longitude }) => {
								setFormData((prev) => ({
									...prev,
									shop_address: address,
									shop_latitude: latitude,
									shop_longitude: longitude,
								}));
							}}
						/>
						<TextField
							label="Clock-in / clock-out radius (feet)"
							name="clock_in_radius_feet"
							type="number"
							value={formData.clock_in_radius_feet}
							onChange={onChange}
							fullWidth
							helperText="Default 500 feet. Allowed range 50–5000. Applies to both clock-in and clock-out."
							inputProps={{ min: 50, max: 5000 }}
						/>
						<FormControlLabel
							control={
								<Switch
									name="allow_clock_in_at_job_addresses"
									checked={Boolean(formData.allow_clock_in_at_job_addresses)}
									onChange={onChange}
								/>
							}
							label="Allow clock-in / clock-out at job site pins"
						/>
						<Typography variant="body2" color="text.secondary" sx={{ mt: -1 }}>
							When on, any job in your org with both site latitude and longitude
							set is an additional allowed zone. Set pins on the job detail
							page.
						</Typography>
						<FormControlLabel
							control={
								<Switch
									name="allow_clock_in_without_location"
									checked={Boolean(formData.allow_clock_in_without_location)}
									onChange={onChange}
								/>
							}
							label="Allow clock-in / clock-out without location"
						/>
						<Typography variant="body2" color="text.secondary" sx={{ mt: -1 }}>
							When off (default), GPS is required and must be inside a zone for
							both clock-in and clock-out. If location is provided but outside
							all zones, the action is still rejected.
						</Typography>
						<Box>
							<Button type="submit" variant="contained" disabled={saving}>
								{saving ? 'Saving...' : 'Save time settings'}
							</Button>
						</Box>
					</Stack>
				</Box>
			)}
		</SectionCard>
	);
};

export default TimeTrackingSection;
